import account from '../images/icons/account.svg';
import arrow_up from '../images/icons/arrow_up.svg';
import assured from '../images/icons/assured.svg';
import ecommerce from '../images/icons/ecommerce.svg';
import trackntrace from '../images/icons/trackntrace.svg';
import search from '../images/icons/search-new.svg';
import openMenu from '../images/icons/menu.svg';
import closeMenu from '../images/icons/close-menu.svg';
import closeMenuThick from '../images/icons/close-menu-thick.svg';
import warning from '../images/icons/warning.svg';
import daanDefault from '../images/icons/daan-default.svg';
import paperPlane from '../images/icons/paper-plane.svg';
import liveAgent from '../images/icons/live-agent.svg';
import checkThin from '../images/icons/check-thin.svg';
import daanError from '../images/icons/daan-error.svg';
import loaderSpinner from '../images/icons/loader-spinner.svg';
import error from '../images/icons/error.svg';
import chevronDown from '../images/icons/chevron-down.svg';
import plus from '../images/icons/plus.svg';
import loggedInConsumer from '../images/icons/logged-in-consumer.svg';
import loggedInBusiness from '../images/icons/logged-in-business.svg'
import lock from '../images/icons/lock.svg';
import deliveredHome from '../images/icons/delivered-home.svg';
import fromMe from '../images/icons/from-me.svg';
import happy from '../images/icons/happy.svg';
import shoppingCart from '../images/icons/shopping-cart.svg';
import suitcase from '../images/icons/suitcase.svg';
import errorMessage from '../images/icons/error-message.svg';
import threeDots from '../images/icons/three-dots.svg';
import buttonHover from '../images/icons/button-hover.svg';
import calender from '../images/icons/calendar_solid.svg';
import clock from '../images/icons/clock.svg';
import microfoon from '../images/icons/microfoon.svg';
import packageToMe from '../images/icons/packageToMe.svg';
import chevronRight from '../images/icons/chevronRight.svg';
import bubbleThreeDots from "../images/icons/bubble-three-dots.svg";
import gear from '../images/icons/gear.svg';
import label from "../images/icons/label.svg";
import paperClip from "../images/icons/paperClip.svg";
import disabledPaperClip from "../images/icons/disabledPaperClip.svg"
import success from "../images/icons/succes-icon.svg"
import errorNotification from "../images/icons/error-notification.svg"
import succesIcon from "../images/icons/new-succes-icon.svg"
import warningIcon from "../images/icons/warning-icon.svg"
import errorIcon from "../images/icons/error-icon.svg"
import infoIcon from "../images/icons/info-icon.svg"

export const images = {
    account,
    arrow_up,
    assured,
    ecommerce,
    trackntrace,
    search,
    plus,
    openMenu,
    closeMenu,
    closeMenuThick,
    warning,
    daanDefault,
    daanError,
    paperPlane,
    liveAgent,
    checkThin,
    loaderSpinner,
    error,
    chevronDown,
    loggedInConsumer,
    loggedInBusiness,
    lock,
    deliveredHome,
    fromMe,
    happy,
    shoppingCart,
    suitcase,
    errorMessage,
    threeDots,
    buttonHover,
    calender,
    clock,
    microfoon,
    packageToMe,
    chevronRight,
    bubbleThreeDots,
    label,
    gear,
    paperClip,
    disabledPaperClip,
    success,
    errorNotification,
    succesIcon,
    errorIcon,
    warningIcon,
    infoIcon
}
